import styled from 'styled-components';
import { Paper, FormControl } from '@material-ui/core';
import { motion } from 'framer-motion';

export const Container = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;

  img {
    width: 90%;
    margin-bottom: 30px;
  }

  .sombra {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.40); // sombra projetada
    border-radius: 8px;
    transition: box-shadow 200ms ease;
  }

  .btnLogin {
    position: relative; 
    display: inline-table; 
    cursor: pointer;
    width: 90px;
    top: 30px
  }
  .btnLogin img:first-child {
    height: 55px;
    border-radius:12px; 
    box-shadow: rgba(0, 0, 0, 1) 2px 4px 8px;
    opacity: 0.70;
  }  
  .btnLogin img:last-child {
    position: absolute;
    top: 30%;
    left: 45%;
    height: 55px;
    transform: translate(-50%, -50%);
    opacity: 0.00;

    &:hover {
        opacity: 0.5;
        box-shadow: rgba(0, 0, 0, 1) 2px 4px 8px;
        border-radius:12px; 
      }
  } 
`;

export const FormContainer = styled(Paper)`
  padding: 24px;
  width: 100%;
  margin: auto;

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
      font-size: 10px;
    }

    .entrar {
      background-color: rgb(250 156 18);
      margin-right: 24px;

      :hover {
        background-color: rgb(203 123 6);
      }
    }
  }
`;

export const InputControl = styled(FormControl)`
  && {
    margin-bottom: 24px;
  }
`;
